import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import "./form-item-legal-assist-cmb.component.scss";
var FormItemLegalAssistCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemLegalAssistCmb, _super);
    function FormItemLegalAssistCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemLegalAssistCmb.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-legal-assist-cmb__button");
    };
    FormItemLegalAssistCmb.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemLegalAssistCmb.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var postData = "";
        var _firstName = this.form.querySelector("input[name=firstName]");
        if (_firstName) {
            postData += "firstname=" + _firstName.value;
        }
        var _lastName = this.form.querySelector("input[name=lastName]");
        if (_lastName) {
            postData += "&surname=" + _lastName.value;
        }
        var _phoneNumber = this.form.querySelector("input[name=phoneNumber]");
        if (_phoneNumber) {
            postData += "&contact=" + _phoneNumber.value;
        }
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/OksLeadsForm.jsp";
        // service
        this.formsService
            .postForm(url, postData)
            .then(function (response) {
            loader.classList.remove("active");
            if (!response.data ||
                response.data
                    .toString()
                    .toLowerCase()
                    .includes("invalid") ||
                response.data["error"] === "true") {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid response");
                thankYou.classList.add("active");
                success.classList.remove("active");
                success.classList.add("hidden");
                error.classList.remove("hidden");
                error.classList.add("active");
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete("complete", response.code, false, "", "", _phoneNumber.value);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete("complete", response.status, false, "", "", _phoneNumber.value);
                }
                else {
                    analyticsService.dtmFormComplete("complete", "200", false, "", "", _phoneNumber.value);
                }
                thankYou.classList.add("active");
                error.classList.remove("active");
                error.classList.add("hidden");
                success.classList.remove("hidden");
                success.classList.add("active");
            }
        })
            .catch(function (response) {
            // service failed
            console.log(response);
            analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemLegalAssistCmb;
}(Base));
export { FormItemLegalAssistCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-legal-assist-cmb/form-item-legal-assist-cmb.component.ts
// module id = 935
// module chunks = 0